import { render, staticRenderFns } from "./SPRSimpleCheckboxList.vue?vue&type=template&id=250c7b50"
import script from "./SPRSimpleCheckboxList.vue?vue&type=script&lang=ts"
export * from "./SPRSimpleCheckboxList.vue?vue&type=script&lang=ts"
import style0 from "./SPRSimpleCheckboxList.vue?vue&type=style&index=0&id=250c7b50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports